module.exports = __webpack_public_path__ + "img/螺丝.fca19f95.png";